import styled from 'styled-components';
import { TooltipContent } from '@components/ui/tooltip';
export const DateTimeRelativeTextTooltipContent = styled(TooltipContent).withConfig({
  componentId: "sc-1y9iiy6-0"
})(["", ""], {
  "zIndex": "2000",
  "overflow": "visible",
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(32 41 57 / var(--tw-bg-opacity, 1)) !important",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
});